import AOS from 'aos';

export default class AOSHandler {
    constructor() {
        this.init();
    }

    init() {
        AOS.init({
            easing: 'ease-out-quad',
            once: true,
            duration: 600
        });
    }
}
